/**
 * Récupère le nom du canal (en prenant en compte la délégation).
 * @param {object} param0
 * @param {object} param0.configuration
 * @param {object} param0.room
 */
export default function bookingDelegationGetName({
  configuration,
  room,
}: {
  room: ReturnType<
    typeof import("../../../normalizers/room/parseResource").default
  >;
  configuration: ReturnType<
    typeof import("../../../normalizers/configuration/parseData").default
  >;
}) {
  const { useBookingDelegation } = configuration.channel.website;
  if (useBookingDelegation) {
    for (const [delegatedChannelId, delegatedChannel] of Object.entries(
      configuration.channel.website.delegatedChannels
    )) {
      if (room.mainChannel.channelId === delegatedChannelId) {
        return delegatedChannel.name;
      }
    }
  }
  return configuration.channel.title;
}
